import { Text } from '@mantine/core';
import { modals } from '@mantine/modals';

import { Transit, TransitGroup } from '@e-origin/shared';

import { DuplicateTransit, FinalizeTransit, NewTransit } from './';
import { getTransitDuplicationModalTitle } from '../helpers';

export const transitModalManager = {
  openCreateTransit: (transitView: TransitGroup) => {
    modals.open({
      title: 'New Transit',
      children: <NewTransit transitView={transitView} onHide={modals.closeAll} afterCreate={() => void 0} />,
      size: 'lg',
    });
  },
  openDeleteTransit: (transitId: string, onConfirm: (transitId: string) => void) => {
    modals.openConfirmModal({
      title: 'Delete Transit',
      children: <Text>Are you sure you want to delete this transit? This action cannot be undone!</Text>,
      labels: { confirm: 'Delete', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onConfirm: () => onConfirm(transitId),
    });
  },
  openFinalize: (transitId: string) => {
    modals.open({
      title: 'Finalize Transit',
      children: <FinalizeTransit transitId={transitId} onHide={modals.closeAll} />,
      size: 'fit-content',
    });
  },
  openDuplicate: (transit: Transit) => {
    modals.open({
      title: getTransitDuplicationModalTitle(transit),
      children: <DuplicateTransit transit={transit} onHide={modals.closeAll} />,
      size: 'lg',
    });
  },
};
